/**
 * Supabase JS surfaces FunctionsHttpError as a generic
 * "Edge Function returned a non-2xx status code" message.
 * The real body lives on error.context (a Response).
 */
export async function getFunctionsErrorMessage(
  error: unknown,
  fallback = 'Edge function request failed'
): Promise<string> {
  if (!error) return fallback;

  const err = error as {
    message?: string;
    context?: { json?: () => Promise<unknown>; clone?: () => { json: () => Promise<unknown> } };
  };

  const readBody = async (): Promise<unknown> => {
    if (!err.context) return null;
    try {
      if (typeof err.context.clone === 'function') {
        return await err.context.clone().json();
      }
      if (typeof err.context.json === 'function') {
        return await err.context.json();
      }
    } catch {
      return null;
    }
    return null;
  };

  const body = await readBody();
  if (body && typeof body === 'object') {
    const record = body as Record<string, unknown>;
    if (typeof record.error === 'string' && record.error.trim()) return record.error;
    if (typeof record.message === 'string' && record.message.trim()) return record.message;
  }

  if (typeof err.message === 'string' && err.message.trim()) return err.message;
  return fallback;
}
